import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-download\"><path d=\"M15 14v1H5v-1H4v2h12v-2h-1Zm-.146-5.146-.707-.707-3.647 3.646V4h-1v7.793L5.854 8.147l-.708.707L10 13.707l4.854-4.854Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol